export function Login(): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-ink-700 bg-ink-800/60 p-10 shadow-drag backdrop-blur">
        <div className="mb-8 text-center">
          <div className="text-4xl text-ink-50">Breeze</div>
          <div className="mt-1 text-[12px] font-medium uppercase tracking-[0.28em] text-ink-50">
            Pipeline
          </div>
        </div>

        <h1 className="mb-2 text-center text-2xl text-ink-50">
          Sign in
        </h1>
        <p className="mb-8 text-center text-[13px] leading-relaxed text-ink-200">
          Only Breeze staff emails on the allowlist can access the board.
          You'll be redirected to Google to authenticate.
        </p>

        <a
          href="/api/auth/google"
          className="group flex w-full items-center justify-center gap-3 rounded-lg border border-slack-aubergineLight bg-slack-aubergine px-5 py-3 text-sm font-semibold text-ink-50 transition-all duration-150 hover:-translate-y-[1px] hover:bg-slack-aubergineLight hover:shadow-cardHover"
        >
          <svg viewBox="0 0 24 24" className="h-4 w-4" aria-hidden>
            <path
              fill="currentColor"
              d="M21.35 11.1H12v2.9h5.35c-.26 1.45-1.8 4.25-5.35 4.25-3.22 0-5.85-2.66-5.85-5.95 0-3.28 2.63-5.95 5.85-5.95 1.83 0 3.06.78 3.76 1.45l2.57-2.48C17.05 3.85 14.78 3 12 3 6.98 3 3 7 3 12s3.98 9 9 9c5.2 0 8.65-3.64 8.65-8.78 0-.58-.06-1.03-.15-1.52z"
            />
          </svg>
          Sign in with Google
          <span className="ml-1 translate-x-0 opacity-60 transition-transform group-hover:translate-x-0.5">
            →
          </span>
        </a>

        <div className="mt-8 text-center text-[12px] text-ink-200">
          <span>Can't get in? Ask Darren to add your email.</span>
        </div>
      </div>
    </div>
  );
}
